var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ku",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M0,0H512V512H0Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M0,0H512V170.667H0Z",
    fill: "#ed2024",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M0,400H512V570.667H0Z",
    transform: "translate(0 -58.667)",
    fill: "#278e43",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M427.938,150l9.591,65.079,28.349-59.36-10.016,65.015,44.586-48.367L471.714,231.54l56.861-33.076-44.9,48.075,64.084-14.847L490.684,264.4l65.613,4.7-64.179,14.429,61.312,23.833-65.58-5.129,51.563,40.846-61.155-24.232,37.233,54.229-51.3-41.181,19.594,62.8-36.879-54.472L447.122,406l-19.184-62.921L408.754,406l.214-65.781-36.879,54.472,19.594-62.8-51.3,41.182,37.233-54.23-61.155,24.232,51.563-40.846-65.58,5.129,61.312-23.834L299.58,269.1l65.613-4.7-57.075-32.706L372.2,246.539l-44.9-48.075,56.861,33.075-28.735-59.173,44.586,48.367L390,155.718l28.349,59.36Z",
    transform: "translate(-171.938 -22)",
    fill: "#febd11",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKu);
export default __webpack_public_path__ + "static/media/ku.ba1bc582fa1f27e2359b87b8f15623ba.svg";
export { ForwardRef as ReactComponent };